import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '~/store'
import { useAppSelector } from '~/store/hooks'
import { Obstruction } from '~/store/objects/types'

const selectSelectedObstruction = createSelector(
  [(state: RootState) => state.objects.present.obstructions, (state: RootState) => state.selectedObjects],
  (obstructions, selectedObjects) =>
    selectedObjects.map(({ id }) => obstructions[id]).filter((obstruction): obstruction is Obstruction => !!obstruction)
)

export const useSelectedObstructions = () => useAppSelector(selectSelectedObstruction)
